import { If, location, onMount } from 'cdui-js';
import i18n from '../../../../i18n';
import { goBackByBrowser } from '../../../../lib/browser';
import { bootDepositApp, fundRecordsUrl, isFundHideNav } from './appBridge';
import { IconBack } from './icons';

type ShellProps = {
  title?: string;
  /** 记录入口文案，缺省「入金记录」 */
  recordLabel?: string;
  onRecord?: () => void;
  /** 滚动区类名，缺省 deposit-scroll */
  scrollClass?: string;
  footer?: any;
  children?: any;
};

export const DepositShell = (props: ShellProps) => {
  onMount(() => {
    void bootDepositApp();
  });

  const openRecord = () => {
    if (props.onRecord) props.onRecord();
    else location.routeTo(fundRecordsUrl('deposit'));
  };

  const hideNav = isFundHideNav();

  return (
    <div class="deposit-h5">
      <If when={!hideNav}>
        <div class="nav">
          <button type="button" class="nav-back" onclick={() => goBackByBrowser()}>
            <IconBack />
          </button>
          <div class="nav-title">{props.title || i18n.H5Deposit.Title}</div>
          <button type="button" class="nav-right" onclick={openRecord}>
            {props.recordLabel || i18n.H5Deposit.Records}
          </button>
        </div>
      </If>
      <div class={props.scrollClass || 'deposit-scroll'}>{props.children}</div>
      {props.footer}
    </div>
  );
};
